import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_PARTNER_GROUP_GET_BY_ID } from 'api/utilityActionTypes';

export default async function getById({ state, utilityApiClient }, { id, forceRefresh = false }) {
  typeCheck('id::PositiveNumber', id);

  const currentPartnerStatePath = ['utilityPartnerGroups', 'byId', id];
  if (state.get(currentPartnerStatePath) && !forceRefresh) {
    return state.get(currentPartnerStatePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PARTNER_GROUP_GET_BY_ID,
    queryId: id,
    state: state,
    payload: {
      id,
    },
    onSuccess(partner) {
      if (partner) {
        state.set(currentPartnerStatePath, partner);
      }
    },
  });
}
